import { Routes } from '@angular/router';
import { LayoutTemplateComponent } from '@layout/layout-template/layout-template.component';
import { LayoutErrorComponent } from '@layout/layout-error/layout-error.component';
import { LayoutLoginComponent } from '@layout/layout-login/layout-login.component';
import { RoleGuard } from '@core/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutTemplateComponent,
    canActivate: [RoleGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'dashboard',
        loadComponent: () =>
          import('@features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },

      {
        path: 'orden-compra',
        loadChildren: () =>
          import('@features/orden-compra/orden-compra.routes').then(
            (m) => m.ORDEN_COMPRA_ROUTES,
          ),
      },

      {
        path: 'despacho',
        loadChildren: () =>
          import('@features/despacho/despacho.routes').then(
            (m) => m.DESPACHO_ROUTES,
          ),
      },

      {
        path: 'proveedores',
        loadChildren: () =>
          import('@features/proveedores/proveedores.routes').then(
            (m) => m.PROVEEDORES_ROUTES,
          ),
      },

      {
        path: 'herramientas',
        loadChildren: () =>
          import('@features/herramientas/herramientas.routes').then(
            (m) => m.HERRAMIENTAS_ROUTES,
          ),
      },

      {
        path: 'tarifas',
        loadChildren: () =>
          import('@features/tarifas/tarifas.routes').then(
            (m) => m.TARIFAS_ROUTES,
          ),
      },

      {
        path: 'exportaciones',
        loadChildren: () =>
          import('@features/exportaciones/exportaciones.routes').then(
            (m) => m.EXPORTACIONES_ROUTES,
          ),
      },
    ],
  },

  { path: 'login', component: LayoutLoginComponent },
  { path: 'error', component: LayoutErrorComponent },
  { path: '**', redirectTo: 'error' },
];
